__turbopack_context__.v({
  "checkbox": "Checkbox-module__XQ0nEW__checkbox",
  "checkboxContainer": "Checkbox-module__XQ0nEW__checkboxContainer",
  "checkboxWrapper": "Checkbox-module__XQ0nEW__checkboxWrapper",
  "checkmark": "Checkbox-module__XQ0nEW__checkmark",
  "disabledLabel": "Checkbox-module__XQ0nEW__disabledLabel",
  "labelContent": "Checkbox-module__XQ0nEW__labelContent",
});
